module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAAAXNSR0IArs4c6QAAAMJJREFUOE/tlMEJwkAURGdiIdqBQgrQEvRoIJAS0oHagSUEgnrUEmIBQewgVmAFZmSjQsxl+QfBQ/a6898Of/98XnbRpH7oCHIEy5GqYMAFyzyq3nWZqR5KKdwdQAA2YbxfWwBlHjn9qgf0PfinORAyQsYsMAGRfEbZEoMv7QsgnUEWJoo0Azn9XZjKfLkVMHauCFzD+JC2HXrj3AiczYbAorsvvABfP9qACpJAmr4RUgKSbJZqjROAoe/Vzv0tCDB/Ank3tIZA8KZLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileIcon.png
// module id = YsW9
// module chunks = 1